import React from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

export interface BreadcrumbItem {
  label: React.ReactNode;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <ul className="breadcrumb">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <li className="breadcrumb-item">
              <FeatherIcon icon="chevron-right" className="breadcrumb-separator-icon" />
            </li>
          )}
          <li className={item.to ? 'breadcrumb-item' : 'breadcrumb-item active'}>
            {item.to ? <Link to={item.to}>{item.label}</Link> : item.label}
          </li>
        </React.Fragment>
      ))}
    </ul>
  );
};

export default Breadcrumb;
